import React from 'react';
import { useTranslation } from 'react-i18next';
import { isGoalkeeper } from '../../utils/playerDiscovery';
import './playerRoleBadge.css';

export default function PlayerRoleBadge({ player }) {
  const { t, i18n } = useTranslation('players');
  if (!isGoalkeeper(player)) return null;
  const english = i18n.language?.startsWith('en');
  const label = t('position.goalkeeper', { defaultValue: english ? 'Goalkeeper' : 'Portero' });
  return <span className="player-role-badge" aria-label={label} title={label}>
    {t('position.goalkeeperShort', { defaultValue: english ? 'GK' : 'POR' })}
  </span>;
}
